module.exports = new __parcel__URL__("yellow-submarine.14b1dbe7.jpg").toString();